<template>
  <div>
    <CRow>
      <CCol col="12">
        <CCard>
          <CCardHeader>
            <strong>{{ $t('notification_center') }}</strong>
          </CCardHeader>
          <CCardBody>
            <CTabs>
              <CTab title="Telegram">
             <CRow v-if="telegram_code.telegram_code!=null">
               <CCol col="12">
                 <div>{{ $t('insert_telegram_bot') }}</div>
                 <div v-if="$i18n.locale=='en'">@bookmeto_bot</div>
                 <div v-if="$i18n.locale=='fa'">@rezerveto_bot</div>
               </CCol>
               <hr>
               <CCol col="12 ">
                 <div>{{ $t('insert_telegram_login_code') }}</div>
                 <div class="border p-2" style="width: fit-content">
                 <span id="telegram_code_root">{{telegram_code.telegram_code}}</span>
                   <CButton size="sm" class="mx-2" color="primary" @click="copy_telegram_code()">
                     <CIcon name="cil-clone"/>
                   </CButton>
                 </div>
               </CCol>
               <hr>

               <CCol col="12 ">
                 <div>{{ $t('telegram_connection_status') }}</div>
                 <div v-if="telegram_code.telegram_enabled"  class="text-success">{{ $t('connected') }}</div>
                 <div v-else class="text-danger">{{ $t('disconnect') }}</div>

               </CCol>
             </CRow>
              </CTab>

            </CTabs>


          </CCardBody>
        </CCard>
      </CCol>
    </CRow>



  </div>

</template>

<script>
import axios from "axios";


// import the styles

export default {
  name: 'Login',
  components: {},
  data() {

    return {
      telegram_code:{}
    }
  },
  mounted() {

    this.get_telegram_info();

  },
  watch: {},
  methods: {
    copy_telegram_code() {
      const text = document.getElementById('telegram_code_root').innerText;
      var self  =this
      // استفاده از Clipboard API برای کپی کردن متن
      navigator.clipboard.writeText(text)
          .then(() => {
            var res={data: {error: 0, msg: " copied successfully!"}}
            self.$root.modal_component.show_api_response_modals(res);
          })
          .catch(err => {
            var res={data: {error: 0, msg: "Copy error occurred."}}
            self.$root.modal_component.show_api_response_modals(res);

          });
    },
    get_telegram_info() {
      var self = this;
      var formData = new FormData();
      axios.post('/api/admin/site/generate_telegram_bot_code', formData, {}).then(function (response) {


        self.telegram_code = response.data


      })
          .catch(function (error) {

            console.log(error);
          });

    },

  }
}


</script>
<style scoped>
/* Responsive styles for mobile */
@media (max-width: 768px) {
  .c-card-body {
    padding: 1rem;
  }

  .c-tabs {
    overflow-x: auto;
  }

  .c-tab-content {
    padding: 1rem 0;
  }

  /* Ensure inputs are full width on mobile */
  .c-form-group {
    margin-bottom: 1rem;
  }

  /* Image selector responsive */
  ::v-deep .image-selector {
    margin-bottom: 1.5rem;
  }

  /* Button responsive */
  .c-btn {
    width: 100%;
    margin-top: 1rem;
  }
}

/* Tablet styles */
@media (min-width: 769px) and (max-width: 1024px) {
  .c-col-md-4 {
    flex: 0 0 50%;
    max-width: 50%;
  }
}
</style>
